export const livenessRedirectPath = '/liveness-redirect'
